export default __webpack_public_path__ + "static/media/mqtt-icon.cbd6e24a.svg";